<template>
  <BaseTooltip :direction="direction">
    <slot></slot>
    <template #content>
      <div class="d-flex main-container">
        <div
          class="d-flex flex-column item-container card-language-list"
          v-for="key in itemsKeys"
          :key="key"
        >
          <div class="d-flex align-center border-bottom-primary">
            <div
              style="max-width: 30px; max-height: 24px"
              v-if="items[key].iconFile"
            >
              <simple-svg
                :src="require(`@/assets/${items[key].iconFile}.svg`)"
                fill-class-name="fill-color"
                fill="var(--v-neutral-base)"
                width="32px"
                height="24px"
              />
            </div>
            <span
              class="font-weight-medium neutral--text text-body-2"
              :class="{ 'ml-3': items[key].iconFile }"
              >{{ items[key].label }}</span
            >
          </div>
          <v-divider color="gray"></v-divider>
          <div
            v-for="item in items[key].items.sort()"
            :key="`${key}__${item}`"
            class="d-flex align-center"
          >
            <template v-if="getCountryCodeBySrcLang(item)">
              <country-flag
                :country="getCountryCodeBySrcLang(item)"
                class="list-item__flag"
              />
              <span class="font-weight-regular neutral--text text-body-2"
                >{{ getLangCodeBySrcLang(item).label
                }}<template v-if="item === originalLang">
                  (Original)</template
                ></span
              >
            </template>
          </div>
        </div>
        <v-divider
          v-if="itemsKeys.length > 1"
          color="gray"
          class="vertical-divider-position"
          vertical
        ></v-divider>
      </div>
    </template>
  </BaseTooltip>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import BaseTooltip from './BaseTooltip.vue'
import langCodes from '@/utils/langCodes.mixin.js'
import { method } from 'lodash'

export default {
  name: 'FlagTooltip',
  components: { BaseTooltip, CountryFlag },
  mixins: [langCodes],
  props: {
    items: {
      type: Object,
      required: true,
    },
    originalLang: {
      type: String,
      default: '',
    },
    direction: {
      type: String,
      default: 'bottom',
    },
  },
  data: () => ({
    /* Example of "items" prop
    items: {
      subtitles: {
        label: 'Legenda',
        iconFile: 'cc_tooltip',
        items: ['pt', 'en', 'es'],
      },
      audios: {
        label: 'Dublagem',
        iconFile: 'dubbing',
        items: ['pt'],
      },
    },*/
  }),
  computed: {
    itemsKeys() {
      return Object.keys(this.items)
    },
  },
  method,
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/src/_ai_works';

.main-container {
  gap: 24px;
  position: relative;
}

.item-container {
  gap: 16px;
}

.vertical-divider-position {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-400%, 0);
}
</style>
